import { createAction } from "redux-ts";
import { storagePayload } from "../../models";

export const storeData = createAction<storagePayload>("LOCALDATA::STORE_DATA");
export const getData = createAction<string>("LOCALDATA::GET_DATA");
